import React, { useState, useEffect, useCallback } from 'react';
import styled from 'styled-components'
import moment from 'moment';
import 'moment/locale/pt-br';

import { Box, SelectInput } from 'vqp-common'
import { DateInput, Button } from '../common'

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`

const Card = styled(Box)`
    display: flex;
    flex-direction: row;
    padding: 20px;
`

const Title = styled.div`
    font-size: 15px;
    font-weight: 700;
    color: ${props => props.theme.colors.textBold}
` 

const MonthField = styled.div`
    display: flex;
    flex-direction: column;
    width: 120px;
    margin-right: 20px;
    margin-bottom: 20px;
    height: 60px;
`

const DateField = styled.div`
    display: flex;
    flex-direction: column;
    width: 320px;
    height: auto;
    margin-right: 80px;
`

const Label = styled.span`
margin-bottom: 6px;
    font-size: 14px;
    color: ${props => props.theme.colors.textPrimary};
`

const DateIntervalWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
`

const Space = styled.div`
    flex-grow: 1;
    text-align: center;
    padding: 0 10px;
    margin-right: 6px;
`

const ButtonWrapper = styled.div`
    align-self: flex-end;
    justify-content: center;
    align-items: center;
    margin-bottom: 18px;
    height: 33px;
    margin-left: 0px;
`

const DateError = styled.div`
    font-size: 10px;
    color: ${props => props.theme.colors.error};
`

const monthOptions = []
moment.locale('pt-BR');
const now = moment();
monthOptions.push({
    name: now.format('MMMM YYYY'),
    value: now.format('YYYY-MM')
})
for (let i = 0; i < 6; i++) {
    now.add(-1, 'month');
    monthOptions.push({
        name: now.format('MMMM YYYY'),
        value: now.format('YYYY-MM')
    })
}

export const FilterBox = ({defaultDates, onFilter}) => {

    const [selectedMonth, setSelectedMonth] = useState(-1)
    const [initialDate, setInitialDate] = useState(defaultDates.initial)
    const [finalDate, setFinalDate] = useState(defaultDates.final)
    const [error, setError] = useState('')
    const [shouldFilter, setShouldFilter] = useState(false)

    const setDateInterval = (date) => {
        setError('')
        const month = moment(date)
        const initialValue = month.startOf('month').toDate();
        const finalValue = month.endOf('month').toDate();
        setInitialDate(initialValue);
        setFinalDate(finalValue);
    }

    const validateInterval = useCallback(() => {
        if (moment(finalDate).isBefore(initialDate)) {
            setError("A data final não pode ser antes da final!")
            return false
        }
        return true
    }, [
        finalDate, initialDate
    ])

    const handleFilter = useCallback(() => {
        if (validateInterval()) {
            onFilter({initial: moment(initialDate).format('YYYY-MM-DD'), final: moment(finalDate).format('YYYY-MM-DD')})
        }
    }, [
        finalDate, initialDate, onFilter, validateInterval
    ])

    const handleMonthSelect = (selectedIndex) => {
        if (selectedIndex > -1) {
            setDateInterval(monthOptions[selectedIndex].value)
        }
        setSelectedMonth(selectedIndex)
        setShouldFilter(true)
    }

    const handleInitialDateChange = (initialValue) => {
        setError('')
        setSelectedMonth(-1)
        setInitialDate(initialValue)
    }

    const handleFinalDateChange = (finalValue) => {
        setError('')
        setSelectedMonth(-1)
        setFinalDate(finalValue)    
    }

    useEffect(() => {
        if (shouldFilter) {
            handleFilter()
            setShouldFilter(false)
        }
    }, [handleFilter, shouldFilter])

    return (
        <Wrapper>
            <Title>Período</Title>
            <Card>
                <MonthField>
                    <Label>Mês</Label>
                    <SelectInput placeholder="Personalizado" selected={selectedMonth} onSelect={handleMonthSelect} options={monthOptions} />
                </MonthField>
                <DateField>
                    <Label>Data</Label>
                    <DateIntervalWrapper>
                        <DateInput value={initialDate} onChange={handleInitialDateChange} />
                        <Space>a</Space>
                        <DateInput value={finalDate} onChange={handleFinalDateChange} />
                    </DateIntervalWrapper>
                    <DateError>
                        {error}
                    </DateError>
                </DateField>
                <ButtonWrapper>
                    <Button className="success" width={"80px"} onClick={handleFilter}>Filtrar</Button>
                </ButtonWrapper>
            </Card>
        </Wrapper>
    )
}

